import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import Tooltip from 'src/common/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faArrowDownToLine, faHexagonCheck } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import Checklist from '../Checklist';
import BidChecklistActionMenu from '../ActionMenu';
import { useChecklistExpand } from 'src/models/bids/BidChecklist/hooks';

export const BidChecklistContainer: FC = () => {
  const { t } = useTranslation();
  const [isExpanded, toggleChecklist] = useChecklistExpand();

  const onCloseHandler = useCallback(
    e => {
      e.preventDefault();
      toggleChecklist(false);
    },
    [toggleChecklist]
  );

  return (
    <div className={classNames(styles.checklistContainer, { [styles.isOpen]: isExpanded })}>
      <div className={styles.checklistHeader}>
        <FontAwesomeIcon icon={faHexagonCheck} className={classNames(styles.icon, styles.checkIcon)} />

        <div className={styles.checklistTitle}>{t('Checklist.checklist')}</div>

        <Tooltip title={t('Checklist.ChecklistDesc')}>
          <FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.icon, styles.infoIcon)} />
        </Tooltip>

        <div className={styles.checklistActions}>
          <BidChecklistActionMenu />
          <button className={styles.checklistsCloseButton} onClick={onCloseHandler}>
            <FontAwesomeIcon icon={faArrowDownToLine} />
          </button>
        </div>
      </div>
      <Checklist />
    </div>
  );
};
export default BidChecklistContainer;
